import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AppConfigService {

  constructor() { }
  static settings: any = {};

    load() {
      AppConfigService.settings.apiUrl = environment.apiUrl;
      //AppConfigService.settings.baseUrl = environment.baseUrl;
      //AppConfigService.settings.umpUrl = environment.umpUrl;
        return AppConfigService.settings;
    }
}
